
























































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import { listAdmin, delListAdmin } from "@/req/staffPower";
import addModel from "./components/addModel.vue";
import editModel from "./components/editModel.vue";

@Component({
  components: { headerTitle, addModel, editModel },
})
export default class Home extends Vue {
  public loading = false;
  public page = 1;
  public size = 10;
  public account: any = "";
  public columns = [
    {
      type: "index",
      width: 60,
      align: "center",
    },
    {
      title: "账号",
      key: "username",
      align: "left",
    },
    {
      title: "操作",
      key: "action",
      slot: "action",
      align: "center",
    },
  ];
  public data: any = [];
  public mounted() {
    this.getList();
  }
  public change(i) {
    this.page = i;
    this.getList();
  }
  public seach() {
    this.page = 1;
    this.getList();
  }
  public async getList() {
    this.loading = true;
    const res = await listAdmin({
      token: this.$fn.cookies.getToken("token"),
      account: this.account == undefined ? "" : this.account,
      page: this.page,
      pagenum: this.size,
    });
    if (res.code == 0) {
      this.data = res.data;
      this.loading = false;
    }
  }
  public addModels() {
    const $addModel: any = this.$refs.addModel;
    $addModel.show();
  }
  public edit(row) {
    const $editModel: any = this.$refs.editModel;
    $editModel.show(row);
  }
  public deletes(row) {
    this.$Modal.confirm({
      title: "确定要删除？",
      onOk: () => {
        this.getDeletes(row.id);
      },
    });
  }
  public async getDeletes(ids) {
    const res = await delListAdmin({
      token: this.$fn.cookies.getToken("token"),
      id: ids,
    });
    if (res.code == 0) {
      this.$Message.success(res.msg);
      this.page = 1;
      this.getList();
    }
  }
}
